import React from 'react';
import LightShadow from '../../base/LightShadow';
const DEFCOUNT = new Array(14).fill(null); // 目前设计稿一排最多展示7个
const CardShimmer = ({ cols, ratio }) => {
  return (
    <div className="flex w-full flex-wrap pl-4">
      {DEFCOUNT.map((_, idx) => (
        <div className="pr-4 pb-4 " style={{ width: `${100 / cols}%`, aspectRatio: ratio }} key={idx}>
          <LightShadow />
        </div>
      ))}
    </div>
  );
};

export default CardShimmer;
